<template>
  <v-navigation-drawer
  clipped app permanent
  :width="210"
  >
    <v-list dense>
      <v-list-item
      v-for="item in items"
      :key="item.title"
      @click="go(item.route)"
      >
        <v-list-item-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-action>
        <v-list-item-content>
          <v-list-item-title>
            {{ item.title }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: 'AsideMenu',
  data: () => ({
    pages: [
      {
        title: 'Состав',
        route: '/persons',
        icon: 'mood',
        scope: 'schooladmins',
      },
      {
        title: 'Классы',
        route: '/positions',
        icon: 'people',
        scope: 'schooladmins',
      },
      {
        title: 'Классные',
        route: '/classheads',
        icon: 'class',
        scope: 'schooladmins',
      },
      {
        title: 'Ответственные',
        route: '/uberclassheads',
        icon: 'star',
        scope: 'schooladmins',
      },
      {
        title: 'Гости',
        route: '/guests',
        icon: 'lock_open',
        scope: 'schooladmins',
      },
      {
        title: 'Проходы',
        route: '/passages',
        icon: 'transfer_within_a_station',
        scope: 'schooladmins',
      },
    ],
    dialogHistory: false
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    scopes () {
      return this.profile ? this.profile.scopes : []
    },
    items () {
      return this.pages
        .filter(x => this.scopes.includes(x.scope))
        .reduce((r, x) => {
          if (!r.find(y => y.route === x.route)) r.push(x)
          return r
        }, [])
    }
  },
  methods: {
    go (route) {
      this.dialogHistory = false
      this.$router.push(route)
    },
  }
}
</script>

<style lang="css">
.history-block {
  position: fixed;
  bottom: 0;
  width: 100%;
}
</style>
